import { render, staticRenderFns } from "./InfoUpFile.vue?vue&type=template&id=77851b24&scoped=true&"
import script from "./InfoUpFile.vue?vue&type=script&lang=js&"
export * from "./InfoUpFile.vue?vue&type=script&lang=js&"
import style0 from "./InfoUpFile.vue?vue&type=style&index=0&id=77851b24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77851b24",
  null
  
)

export default component.exports